import React from "react";
import ReelVideo from "../../Assets/Reel.mp4";
import ReelGif from "../../Assets/Reel.gif";
import ScrollIndicator from "./ScrollIndicator";
import "./Landing.scss";

export default class Landing extends React.Component {
  landingRef = React.createRef();

  state = {
    isDesktop: false,
  };

  componentDidMount() {
    this.mediaQuery = window.matchMedia("(min-width: 768px)");

    this.setState({
      isDesktop: this.mediaQuery.matches,
    });

    this.handleResize = (e) => {
      this.setState({
        isDesktop: e.matches,
      });
    };

    this.mediaQuery.addEventListener("change", this.handleResize);
  }

  componentWillUnmount() {
    this.mediaQuery?.removeEventListener("change", this.handleResize);
  }

  render() {
    const { locoScroll } = this.props;
    const { isDesktop } = this.state;

    return (
      <div
        className="landing-page"
        id="Landing"
        data-scroll-section
        ref={this.landingRef}
      >
        <div className="landing-body">
          {isDesktop ? (
            <video
              autoPlay
              muted
              loop
              playsInline
              preload="auto"
              disablePictureInPicture
              controls={false}
              className="landing-video prevent-click"
            >
              <source src={ReelVideo} type="video/mp4" />
            </video>
          ) : (
            <img src={ReelGif} alt="Reel" className="landing-gif" />
          )}

          <ScrollIndicator
            locoScroll={locoScroll}
            targetRef={this.landingRef}
          />

          <h2 className="landing-caption d-block d-sm-none">
            VFX • Animation • Creative Direction
          </h2>
        </div>
      </div>
    );
  }
}
